import { useState } from "react";
import { ListPicker } from "../../components/generic/ListPicker";
import { SettingItem } from "../../components/orgSettings/SettingsItem";
import { usePickerhook } from "../../hooks/usePickerhook";
import { CiLight } from "react-icons/ci";
import { CiDark } from "react-icons/ci";
import { PiDesktopThin } from "react-icons/pi";
import Switch from "react-switch";

export default () => {
  const [emailnote, setemailnote] = useState(true);
  const [phonenote, setphonenote] = useState(true);
  const [noteall, setnotall] = useState(true);

  const Checkbox = (props: any) => <></>;
  return (
    <div className="w-full pr-20  flex  ">
      <div className={` p-6 bg-white    w-full  rounded-[20px]`}>
        <div className="  w-full  flex justify-between items-center  ">
          <p className="text-textbg font-medium text-sm mb-2 text-[16px] bg-white">
            Notifications
          </p>
        </div>

        <hr />

        <div className="mt-4 flex flex-col gap-2">
          <SettingItem
            title="Email"
            action={
              <Switch
              checkedIcon	={false}
              uncheckedIcon	={false}
              offColor	='#EAECF5'
              onColor	='#CB0E5F'
              className="m-4"

                onChange={() => {
                  setemailnote(!emailnote);
                }}
                checked={emailnote}
              />
            }
          />

          <SettingItem
            title="Phone number"
            action={
              <Switch
              checkedIcon	={false}
              uncheckedIcon	={false}
              offColor	='#EAECF5'
              onColor	='#CB0E5F'
              className="m-4"

                onChange={() => {
                  setphonenote(!phonenote);
                }}
                checked={phonenote}
              />
            }
          />
          <SettingItem
            title="Notify all activity"
            action={
              <Switch
              checkedIcon	={false}
              uncheckedIcon	={false}
              offColor	='#EAECF5'
              onColor	='#CB0E5F'
              className="m-4"
                onChange={() => {
                  setnotall(!noteall);
                }}
                checked={noteall}
              />
            }
          />
        </div>
      </div>
    </div>
  );
};
